// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginLayout__container-eab081 {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--brand-primary-10);
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  padding: 16px;
}

.LoginLayout__main-f49bfc {
  text-align: center;
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
}

.LoginLayout__main-wrapper-f1cf6f {
  position: relative;
  background-color: var(--addition-70);
  border-radius: 32px;
  border: 1px solid var(--base-20);
  box-sizing: border-box;
  min-height: 528px;
  max-width: 432px;
  width: 100%;
  z-index: 2;
  max-height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.LoginLayout__scroll-container-d330da {
  --scrollbar-bg-color: transparent;
  overflow: auto;
}

.LoginLayout__scrollbar-hidden-dc59c4 .LoginLayout__scroll-container-d330da {
  scrollbar-width: none;
}

.LoginLayout__scrollbar-hidden-dc59c4 .LoginLayout__wrapper-ec772f::-webkit-scrollbar {
  display: none;
}

.LoginLayout__scroll-container-d330da + .LoginLayout__footer-dbee28 {
  margin-top: 16px;
}

.LoginLayout__wrapper-ec772f {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.LoginLayout__content-a7f371 {
  padding: 32px;
  max-height: 100%;
  width: 100%;
  box-sizing: border-box;
}

.LoginLayout__background-ba5efe {
  position: absolute;
  height: 100%;
  width: 100%;
  object-fit: cover;
  z-index: 1;
}

.LoginLayout__logo-wrapper-a05c25 {
  display: flex;
  justify-content: center;
  margin-bottom: 32px;
}

@media (max-width: 430px) {
  .LoginLayout__background-ba5efe {
    display: none;
  }
  .LoginLayout__container-eab081 .LoginLayout__main-wrapper-f1cf6f {
    min-height: auto;
    height: 100%;
    max-width: 100%;
    border-radius: 0;
    justify-content: normal;
    border: 0 none;
  }
  .LoginLayout__container-eab081 {
    height: 100dvh;
    max-width: none;
    padding: 0;
  }
  .LoginLayout__scroll-container-d330da {
    flex: 1;
  }
  .LoginLayout__main-f49bfc {
    min-height: auto;
  }
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/layouts/LoginLayout/LoginLayout.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yCAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,OAAA;AACF;;AAEA;EACE,kBAAA;EACA,oCAAA;EACA,mBAAA;EACA,gCAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,iCAAA;EAEA,cAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAAF;;AAGA;EACE,aAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,UAAA;AAAF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAAF;;AAGA;EACE;IACE,aAAA;EAAF;EAGA;IACE,gBAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;IACA,uBAAA;IACA,cAAA;EADF;EAIA;IACE,cAAA;IACA,eAAA;IACA,UAAA;EAFF;EAKA;IACE,OAAA;EAHF;EAMA;IACE,gBAAA;EAJF;AACF","sourcesContent":[".container {\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--brand-primary-10);\n  position: relative;\n  overflow: hidden;\n  box-sizing: border-box;\n  padding: 16px;\n}\n\n.main {\n  text-align: center;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  flex: 1;\n}\n\n.main-wrapper {\n  position: relative;\n  background-color: var(--addition-70);\n  border-radius: 32px;\n  border: 1px solid var(--base-20);\n  box-sizing: border-box;\n  min-height: 528px;\n  max-width: 432px;\n  width: 100%;\n  z-index: 2;\n  max-height: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.scroll-container {\n  --scrollbar-bg-color: transparent;\n\n  overflow: auto;\n}\n\n.scrollbar-hidden .scroll-container {\n  scrollbar-width: none;\n}\n\n.scrollbar-hidden .wrapper::-webkit-scrollbar {\n  display: none;\n}\n\n.scroll-container + .footer {\n  margin-top: 16px;\n}\n\n.wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n.content {\n  padding: 32px;\n  max-height: 100%;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.background {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n  z-index: 1;\n}\n\n.logo-wrapper {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 32px;\n}\n\n@media (max-width: 430px) {\n  .background {\n    display: none;\n  }\n\n  .container .main-wrapper {\n    min-height: auto;\n    height: 100%;\n    max-width: 100%;\n    border-radius: 0;\n    justify-content: normal;\n    border: 0 none;\n  }\n\n  .container {\n    height: 100dvh;\n    max-width: none;\n    padding: 0;\n  }\n\n  .scroll-container {\n    flex: 1;\n  }\n\n  .main {\n    min-height: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `LoginLayout__container-eab081`,
	"main": `LoginLayout__main-f49bfc`,
	"main-wrapper": `LoginLayout__main-wrapper-f1cf6f`,
	"mainWrapper": `LoginLayout__main-wrapper-f1cf6f`,
	"scroll-container": `LoginLayout__scroll-container-d330da`,
	"scrollContainer": `LoginLayout__scroll-container-d330da`,
	"scrollbar-hidden": `LoginLayout__scrollbar-hidden-dc59c4`,
	"scrollbarHidden": `LoginLayout__scrollbar-hidden-dc59c4`,
	"wrapper": `LoginLayout__wrapper-ec772f`,
	"footer": `LoginLayout__footer-dbee28`,
	"content": `LoginLayout__content-a7f371`,
	"background": `LoginLayout__background-ba5efe`,
	"logo-wrapper": `LoginLayout__logo-wrapper-a05c25`,
	"logoWrapper": `LoginLayout__logo-wrapper-a05c25`
};
module.exports = ___CSS_LOADER_EXPORT___;
